import { Box, Button, Fade, Popper, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(() => ({
    card: {
        position: 'relative',
        width: 'fit-content',
        height: 'fit-content',
        padding: '20px 60px',
        backgroundColor: '#fff',
        boxShadow: '0 12px 24px rgba(0,0,0,0.5)',
        borderRadius: 16,
    },
    title: {
        fontFamily: 'Poppins',
        fontWeight: 'bold',
        fontSize: '1.7rem',
        color: '#000',
    },
    subtitle: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontSize: '1rem',
        color: '#666666',
    },
    commonButton: {
        minWidth: 150,
        minHeight: 40,
        borderRadius: 32,
        fontFamily: 'Inter',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        textTransform: 'none',
    },
}));

const UpgradeToProModal: React.FC<{
    isOpen: boolean,
    anchorElement?: HTMLElement|null,
 }> = ({ isOpen, anchorElement }) => {
    const history = useHistory();
    const classes = useStyles();

    return (<>
        <Popper open={isOpen} anchorEl={anchorElement}
            sx={{ marginTop: 'calc(50vh - 300px) !important', zIndex: 1500 }}>
            <Fade in timeout={2000}>
                <Stack className={classes.card} spacing={1} alignItems="center" justifyContent="center" width="100%">
                    <Typography className={classes.title} textAlign="center">
                        {'Upgrade to Pro'}<br />
                    </Typography>
                    <Typography className={classes.subtitle} textAlign="center">
                        {'to view all deals and request intros.'}
                    </Typography>
                    <Box py={1} />
                        <Button variant="contained"
                            className={classes.commonButton}
                            onClick={() => history.push('/subscriptions')}
                        > {'Upgrade'} </Button>
                </Stack>
            </Fade>
        </Popper>
    </>);
}

export default UpgradeToProModal;
